import { render, staticRenderFns } from "./PurchaseOrderMailModalContent.vue?vue&type=template&id=661cf35a"
import script from "./PurchaseOrderMailModalContent.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderMailModalContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports